export const contributors = [
  {
    category: "Research Institutions",
    items: [
      "National University of Singapore (NUS)",
      "University of Buffalo (UB)",
      "National Institute of Informatics (NII)",
      "Indian Institute of Technology (IIT)",
      "International Institute of Information Technology (IIIT)",
      "National Institute of Technology (NIT)",
    ],
  },
  {
    category: "Language Experts",
    items: [
      "Dr. Rajiv Ratn",
      "Dr. Rushali",
      "Dr. Yaman K Singla",
      "Dr. Rajesh Kumar",
      "Dr. Ritwik Mishra",
      "Raj Jaiswal",
      "Ritika Jha",
      "Rohan Kumar",
      "Aman Singla",
    ],
  },
  {
    category: "Data Collection Teams",
    items: [
      "North India Data Collection Team",
      "South India Data Collection Team",
      "East India Data Collection Team",
      "West India Data Collection Team",
      "Central India Data Collection Team",
      "Northeast India Data Collection Team",
    ],
  },
  {
    category: "Open Source Community",
    items: [
      "Mozilla Common Voice",
      "OpenSLR",
      "Indian Language Technology Community",
      "AI4Bharat",
      "Bhashini",
      "Open Source Speech Recognition Community",
    ],
  },
];

export const dataSources = [
  {
    category: "Public Domain Resources",
    items: [
      "Indian Government Public Datasets",
      "Public Domain Audio Collections",
      "Open Educational Resources",
      "Public Domain Literature",
      "Government Speech Databases",
      "Public Domain News Archives",
    ],
  },
  {
    category: "Licensed Datasets",
    items: [
      "Commercial Speech Databases",
      "Research Institution Datasets",
      "Educational Institution Collections",
      "Private Research Datasets",
      "Industry Partner Datasets",
    ],
  },
  {
    category: "Community Contributions",
    items: [
      "Crowdsourced Audio Recordings",
      "Volunteer Transcriptions",
      "Community Language Projects",
      "Public Contributions",
      "Open Source Community Datasets",
    ],
  },
  {
    category: "Research Collaborations",
    items: [
      "Academic Research Projects",
      "Government Research Initiatives",
      "Industry-Academia Partnerships",
      "International Research Collaborations",
      "Cross-Institutional Projects",
    ],
  },
]; 